import { Text } from '../Text';
import { BoxInputState } from './types';
import { styled } from 'styled-components';
import { colors, getFontSize, Size } from '../../abstracts';
import { dontForwardProps } from '../../util';
const getStateColor = state => state === BoxInputState.Error ? colors.errorDeep : state === BoxInputState.Success ? colors.successDeeper : '';
export const BoxInputContainer = styled.div.withConfig({
  componentId: "aui__sc-14108z4-0"
})(["justify-content:center;align-items:center;display:flex;flex-direction:column;"]);
export const BoxInputWrapper = styled.div.withConfig({
  componentId: "aui__sc-14108z4-1"
})(["align-items:center;display:flex;flex-direction:row;width:100%;justify-content:space-around;"]);
export const InputMessage = styled(Text).attrs({
  'aria-hidden': true,
  size: 1
}).withConfig({
  componentId: "aui__sc-14108z4-2"
})(["padding-top:0.5rem;color:", ";"], ({
  state
}) => getStateColor(state) || colors.neutralDeeper);
export const Input = styled.input.withConfig(dontForwardProps()).withConfig({
  componentId: "aui__sc-14108z4-3"
})(["height:4rem;border-radius:0.75rem;margin-right:0.5rem;width:2.5rem;height:3.125rem;font-size:", ";outline:transparent solid 0.125rem;outline-offset:0.125rem;@media (min-width:", "px){width:2.875rem;height:3.6rem;}@media (min-width:400px){width:3rem;height:3.7rem;}@media (min-width:", "px){width:3rem;height:3.7rem;font-size:", ";}@media (min-width:", "px){width:3.5625rem;height:4.3125rem;font-size:", ";}text-align:center;border-width:0.0625rem;border-style:solid;border-color:", ";background-color:inherit;box-sizing:border-box;&:focus{border-color:", ";border-width:0.125rem;}&:last-of-type{margin-right:0;}&:disabled{cursor:not-allowed;opacity:1;background-color:", ";border-color:", ";}"], getFontSize(3), Size.SM, Size.MD, getFontSize(4), Size.XXL, getFontSize(5), ({
  state
}) => getStateColor(state) || colors.neutralDeep, ({
  state
}) => getStateColor(state) || colors.black, colors.disabledBackground, colors.disabledText);